import { createStore } from 'satcheljs';
import { IProfileViewState } from './schema';

// !NOTE: This is to be added explicitly for the orchestrators to register themselves.
import '../orchestrators';

export const getProfileStore = createStore<IProfileViewState>('ProfileViewState', {
  active: {},
  raw: {},
  errors: {},
});
